import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';
import {
  ICreateImageBody,
  ICreateImageResponse,
  IDescribeImageBody,
  IDescribeImageResponse,
  IRemixImageBody,
  IRemixImageResponse,
  IUpScaleImageBody,
  IUpScaleImageResponse,
} from '../data/responses/ideogram';

export class IdeogramService extends ApiService {
  static pathName = '/ideogram';

  static createImage = (
    body: ICreateImageBody,
  ): Promise<IGetOneResponse<ICreateImageResponse>> => {
    return ApiService.post(`${this.pathName}/image`, body);
  };

  static remix = (
    body: IRemixImageBody,
  ): Promise<IGetOneResponse<IRemixImageResponse>> => {
    return ApiService.post(`${this.pathName}/remix`, body);
  };

  static describeImage = (
    body: IDescribeImageBody,
  ): Promise<IGetOneResponse<IDescribeImageResponse>> => {
    return ApiService.post(`${this.pathName}/describe-image`, body);
  };

  static upscaleImage = (
    body: IUpScaleImageBody,
  ): Promise<IGetOneResponse<IUpScaleImageResponse>> => {
    return ApiService.post(`${this.pathName}/upscale`, body);
  };
}
